import {Pipe, PipeTransform} from '@angular/core';
import {getFontIcons} from "../common/get-icons";
@Pipe({
    name: 'PipeIcon', pure: true
})
export class PipeIcon implements PipeTransform {
    transform(value: any): any {
        return getFontIcons({$: {id: value}}).icon;
    }
}
